import {Get, Post} from "../axios.config";
/**
 * @author jiao 2020-11-04 14:21:18
 * 产品对接：石莉 服务端对接：东东 
 * getActivityList 领取页数据列表
 * 
 * method: get
 * url: /v1/payactivity/common_activity/combine_assign_page
 * API文档: https://yapi.quickcan.com/project/347/interface/api/38558
 *
 *  参数            类型        是否必须    备注
 * **/ 
export function getActivityList(params = {}){
    const url = "/v1/payactivity/common_activity/combine_assign_page";
    const mock = "https://yapi.quickcan.com/mock/347/v1/payactivity/common_activity/combine_assign_page";
    return Get({
        url: url,
        data: params
    });
}
/**
 * @author jiao 2020-11-11 17:21:18
 * 产品对接：石莉 服务端对接：东东 
 * getRecordList 领取记录数据列表
 * 
 * method: get
 * url: /v1/payactivity/common_activity/combine_assigned_page
 * API文档: https://yapi.quickcan.com/project/347/interface/api/39874
 *
 *  参数            类型        是否必须    备注
 * **/ 
export function getRecordList(params = {}){
    const url = "/v1/payactivity/common_activity/combine_assigned_page";
    const mock = "https://yapi.quickcan.com/mock/347/v1/payactivity/common_activity/combine_assigned_page";
    return Get({
        url: url,
        data: params
    });
}
/**
 * @author jiao 2020-11-11 17:48:01
 * 产品对接：石莉 服务端对接：东东 
 * postAssignVip 领取聚合页领取会员
 * 
 * method: get
 * url: /v1/payactivity/common_activity/combine_assign
 * API文档: https://yapi.quickcan.com/project/347/interface/api/39878
 *
 *  参数            类型        是否必须    备注
 * **/ 
export function postAssignVip(params = {}){
    const url = "/v1/payactivity/common_activity/combine_assign";
    const mock = "https://yapi.quickcan.com/mock/347/v1/payactivity/common_activity/combine_assign";
    return Post({
        url: url,
        data: params
    });
}
/**
 * @author jiao 2020-11-17 10:59:54
 * 产品对接：石莉 服务端对接：东东 
 * getHomepageInfo n选1模板购买页
 * 
 * method: get
 * url: /v1/payactivity/common_activity/combine_home_page
 * API文档: https://yapi.quickcan.com/project/347/interface/api/38546
 *
 *  参数            类型        是否必须    备注
 * **/ 
export function getHomepageInfo(params = {}){
    const url = "/v1/payactivity/common_activity/combine_home_page";
    const mock = "https://yapi.quickcan.com/mock/347/v1/payactivity/common_activity/combine_home_page";
    return Get({
        url: url,
        data: params
    });
}
/** @author jiao 2020-11-17 11:17:02
 * 产品对接：石莉 服务端对接：张鑫
 * 端内 获取快看商品价格
 * method: GET
 * url:/v1/vip/member_good/list_h5
 * API文档: https://yapi.quickcan.com/project/341/interface/api/5765
 * 参数名          是否必须参数     备注
 **/

export function getKuaikanGood({ data = {}, headers = {} } = {}) {
    const url = "v1/vip/member_good/list_h5";
    return Get({
        url,
        data,
        headers,
        timeout: 1000 * 100,
    });
}

/** @author jiao 2020-12-18
 * 产品对接：石莉 服务端对接：冬冬
 * 申请退款接口
 * method: POST
 * url:/v1/payactivity/common_activity/combine_refund
 * API文档: https://yapi.quickcan.com/project/347/interface/api/42246
 * 参数名          是否必须参数     备注
 **/

export function postRefund(params = {}) {
    const url = "/v1/payactivity/common_activity/combine_refund";
    return Post({
        url,
        data: params
    });
}

/** @author jiao 2020-12-22 10:37:38
 * 产品对接：石莉 服务端对接：冬冬
 * 查询第三方领取结果
 * method: GET
 * url:/v1/payactivity/common_activity/query_order
 * API文档: https://yapi.quickcan.com/project/341/interface/api/5765
 * 参数名          是否必须参数     备注
 **/

export function getQueryOrder(params = {}) {
    const url = "/v1/payactivity/common_activity/query_order";
    return Get({
        url,
        data: params,
    });
}


/** @author jiao 2021-01-13 10:31:11
 * 产品对接：石莉 服务端对接：张鑫
 * 根据订单绑定手机号
 * method: POST
 * url:/v1/vip/link_vip/bind_order_phone
 * API文档: https://yapi.quickcan.com/project/341/interface/api/43036
 * 参数名          是否必须参数     备注
 * 参数名称	  参数类型	是否必须	    示例	         备注
 phone	      文本	  是	   13567876785      手机号
 code	        文本	  是	       1234         验证码
 activity_name	文本	是	 link_vip_activity  活动名称
 award_name	  文本	  是	     send_5_now     奖品名称（父奖品）
 order_id	    文本	  是 2020091512000500035916615 订单id
 **/

export function postBindOrderPhone(params = {}) {
    const url = "/v1/vip/link_vip/bind_order_phone";
    return Post({
        url,
        data: params,
    });
}

/** @author jiao 2021-01-13 11:11:27
 * 产品对接：石莉 服务端对接：张鑫
 * 修改默认手机号
 * method: POST
 * url:/v1/vip/link_vip/select_phone
 * API文档: https://yapi.quickcan.com/project/341/interface/api/43044
 * 参数名          是否必须参数     备注
 * 参数名称	  参数类型	是否必须	    示例	         备注
 phone	      文本	  是	   13567876785      手机号
 activity_name	文本	是	 link_vip_activity  活动名称
 order_id	    文本	  是 2020091512000500035916615 订单id
 **/

export function postChangePhone(params = {}) {
    const url = "/v1/vip/link_vip/select_phone";
    return Post({
        url,
        data: params,
    });
}
/** @author jiao 2021-01-14 11:35:42
 * 产品对接：石莉 服务端对接：张鑫
 * 获取活动手机号列表
 * method: GET
 * url:/v1/payactivity/common_activity/order_account
 * API文档: https://yapi.quickcan.com/project/347/interface/api/43056
 * 参数名          是否必须参数     备注
 award_name	  文本	  是	     send_5_now     奖品名称（父奖品）
 activity_name	文本	是	 link_vip_activity  活动名称
 order_id	    文本	  是 2020091512000500035916615 订单id
 **/

export function getPhoneList(params = {}) {
    const url = "/v1/payactivity/common_activity/order_account";
    return Get({
        url,
        data: params,
    });
}

// 极验相关
export function getGeetestInit() {
    return Get({
        url: "v2/passport/gt/init",
    // apiUrl: 'https://h5.quickcn.cn'
    });
}
// 极验相关
export function postCheckGt(params = {}) {
    return Post({
        url: "v2/passport/gt/check",
        data: params
    });
}
// 获取短信验证码
export function postGetSMSCodeGeetest (params = {}) {
    return Post({
        url: "v1/passport/verify_code/get_sms_code",
        data: params
    });
}


// WEBPACK FOOTER //
// ./src/api/pay/link_vip_multiple.api.js